const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

function isConfigured() {
  return !!GA_ID && /^G-/.test(GA_ID) && !GA_ID.includes("XXXX");
}

let initialized = false;

export function initAnalytics() {
  if (initialized || !isConfigured()) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // send_page_view disabled — the SPA route listener fires page_view explicitly.
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageview(path) {
  if (!isConfigured() || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", { page_path: path });
}

export function trackEvent(name, params = {}) {
  if (!isConfigured() || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
